export const TITLE = "Mahindra Zor Grand Price in 2026 - Range, Specification & Reviews | Turno";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Looking for Mahindra Zor Grand price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "keywords",
    content:
      "Mahindra Zor Grand, Mahindra electric vehicle, Mahindra electric cargo vehicle, Mahindra electric commercial vehicle, Mahindra Zor Grand price, Mahindra Zor Grand specifications, Mahindra Zor Grand range, Mahindra Zor Grand load capacity, Mahindra electric vehicle price, Mahindra commercial vehicle, Mahindra electric auto, Mahindra EV, Mahindra electric truck, Mahindra cargo vehicle, Mahindra electric vehicle specifications, Mahindra electric vehicle features, Mahindra electric vehicle reviews, Mahindra electric vehicle dealer, Mahindra Zor Grand electric truck, Mahindra electric three wheeler, Mahindra SCV",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Mahindra/Zor-Grand",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Mahindra/Zor-Grand",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Mahindra Zor Grand Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    property: "og:description",
    content:
      "Looking for Mahindra Zor Grand price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Looking for Mahindra Zor Grand price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "twitter:title",
    content: "Mahindra Zor Grand Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Mahindra/Zor-Grand",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Mahindra/Zor-Grand";

export const KEY_SPECIFICATION_HEADER = "Key Specifications";

export const HIGHLIGHTS_HEADING = "Product Highlights";

export const HIGHLIGHTS_DESCRIPTION = "The Mahindra Zor Grand is a high-tech 3-wheeler cargo vehicle that offers excellent performance. It has features like fleet management, geofencing, and driver performance monitoring to help you keep track of your business. It is classified as a small commercial vehicle (SCV) and equipped with advanced technology and an efficient battery that requires less maintenance. It also comes with a lithium-ion battery that lasts more than 5 years, and easy road assistance across the country. Mahindra Zor Grand is priced between ₹4.05 and ₹4.43 lakhs.";

export const MOSTLY_BOUGHT_FOR_HEADING = "Mostly bought for";

export const BUSINESS_BENEFIT_HEADING = "Business Benefit with Electric Vehicle";

export const FEATURES_HEADING = "Features of Mahindra Zor Grand";

export const BRAND_DEALER_HEADING = "Mahindra Zor Grand Electric Truck Dealers Near Me:";

export const BRAND_DEALER_DESCRIPITION = "As Mahindra's influence continues to extend across India, its presence is becoming increasingly noticeable. With a rising number of individuals choosing Mahindra's top-notch mobility solutions, known for delivering excellent value for the price, Turno proudly presents the outstanding Mahindra Zor Grand electric commercial vehicle, at an unbelievably budget-friendly price.";

export const FAQ_HEADING_TEXT = "FAQs on Mahindra Zor Grand";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Mahindra", href: "/electric-commercial-vehicles/Mahindra" },
  { label: "Zor Grand" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Mahindra",
      item: "https://www.turno.club/electric-commercial-vehicles/Mahindra",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "Zor Grand",
      item: VEHICLE_LINK,
    },
  ],
};